import React from "react";
import { Box, Typography, Grid, Paper, Fade, Grow } from "@mui/material";
import { Work, TrendingUp, Star } from "@mui/icons-material";
import styled from "styled-components";

const ExperienceCard = styled(Paper)`
  padding: 2rem;
  margin: 1rem 0;
  border-radius: 16px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  }
`;

function ExperienceSection() {
  const experiences = [
    {
      title: "Application Developer II",
      company: "DR Horton",
      description:
        "Currently bringing expertise in application development and system reliability to a new team, continuing to drive innovation and enhance user experiences.",
      icon: <TrendingUp sx={{ color: "#0066CC", mr: 1, fontSize: 28 }} />,
      delay: 1700,
    },
    {
      title: "Application Developer",
      company: "Neighborly",
      description:
        "Contributed to development and launch of multiple applications, built rules engine for call center app, maintained application endpoints improving system reliability.",
      icon: <Star sx={{ color: "#0066CC", mr: 1, fontSize: 28 }} />,
      delay: 1800,
    },
  ];

  return (
    <Box sx={{ mt: 8 }}>
      <Fade in timeout={1600}>
        <Typography
          variant="h4"
          component="h3"
          textAlign="center"
          gutterBottom
          sx={{
            fontWeight: 600,
            mb: 4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Work sx={{ color: "#0066CC" }} />
          Experience
        </Typography>
      </Fade>

      <Grid container spacing={3}>
        {experiences.map((experience, index) => (
          <Grid item xs={12} md={6} key={experience.title}>
            <Grow in timeout={experience.delay}>
              <ExperienceCard elevation={2}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  {experience.icon}
                  <Typography
                    variant="h6"
                    component="h4"
                    sx={{ fontWeight: 600 }}
                  >
                    {experience.title}
                  </Typography>
                </Box>
                <Typography variant="subtitle1" color="primary" gutterBottom>
                  {experience.company}
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  {experience.description}
                </Typography>
              </ExperienceCard>
            </Grow>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default ExperienceSection;
